module.exports = __webpack_public_path__ + "img/img.3bcdeb3b.jpg";